var map = {
	"./addi.jpg": 792,
	"./cffw.jpg": 676,
	"./coex.jpg": 107,
	"./cool.jpg": 217,
	"./maxresdefault.jpg": 295,
	"./mull.jpg": 320,
	"./plac.jpg": 470,
	"./retu.jpg": 816,
	"./shst.jpg": 706,
	"./so89.jpg": 605,
	"./winx.jpg": 36,
	"./zeit.jpg": 794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;